export const RESET = 'DEVICES_LIST/RESET';
export const REQUEST = 'DEVICES_LIST/REQUEST';
export const RECEIVE = 'DEVICES_LIST/RECEIVE';
export const REQUEST_ERROR = 'DEVICES_LIST/REQUEST_ERROR';
export const SET_COLUMNS = 'DEVICES_LIST/SET_COLUMNS';
export const SET_LAST_PROBE = 'DEVICES_LIST/SET_LAST_PROBE';

export const UPDATE_RAW_FILTER = 'UPDATE_RAW_FILTER';
export const UPDATE_FILTER = 'UPDATE_FILTER';
